import simg from '../images/practice/image-1.jpg';
import simg2 from '../images/practice/image-1.jpg';
import simg3 from '../images/practice/image-1.jpg';
import simg4 from '../images/practice/image-1.jpg';
import simg5 from '../images/practice/image-1.jpg';
import simg6 from '../images/practice/image-1.jpg';
import simg7 from '../images/practice/image-1.jpg';
import simg8 from '../images/practice/image-1.jpg';
import simg9 from '../images/practice/image-1.jpg';

import iconCoowner from '../icons/co_ownership.svg';
import iconContract from '../icons/contracts.svg';
import iconCriminal from '../icons/criminal.svg';
import iconFamily from '../icons/familly.svg';
import iconRepair from '../icons/insurance_damage_repair.svg';
import iconResponsibilities from '../icons/responsibilities.svg';
import iconTraffic from '../icons/road_traffic.svg';
import iconSequestration from '../icons/sequestration.svg';
import iconYouth from '../icons/youth.svg';

const Practices = [
	{
		Id: '1',
		sImg: simg,
		sTitle: 'Droit des assurances et réparation du dommage',
		slug: 'assurances-et-reparation-du-dommage',
		icon: iconRepair,
		comp: 'Practice1',
	},
	{
		Id: '2',
		sImg: simg2,
		sTitle: 'Droit de la circulation routière',
		slug: 'circulation-routiere',
		icon: iconTraffic,
		comp: 'Practice2',
	},
	{
		Id: '3',
		sImg: simg3,
		sTitle: 'Droit des contrats\n\u00A0',
		slug: 'contrats',
		icon: iconContract,
		comp: 'Practice3',
	},
	{
		Id: '4',
		sImg: simg4,
		sTitle: 'Droit de la copropriété - Voisinage',
		slug: 'copropriete',
		icon: iconCoowner,
		comp: 'Practice4',
	},
	{
		Id: '5',
		sImg: simg5,
		sTitle: 'Droit familial\n\u00A0',
		slug: 'familial',
		icon: iconFamily,
		comp: 'Practice5',
	},
	{
		Id: '6',
		sImg: simg6,
		sTitle: 'Droit de la jeunesse\n\u00A0',
		slug: 'jeunesse',
		icon: iconYouth,
		comp: 'Practice6',
	},
	{
		Id: '7',
		sImg: simg7,
		sTitle: 'Droit pénal',
		slug: 'penal',
		icon: iconCriminal,
		comp: 'Practice7',
	},
	{
		Id: '8',
		sImg: simg8,
		sTitle: 'Droit de la responsabilité',
		slug: 'responsabilite',
		icon: iconResponsibilities,
		comp: 'Practice8',
	},
	{
		Id: '9',
		sImg: simg9,
		sTitle: 'Droit des saisies',
		slug: 'saisies',
		icon: iconSequestration,
		comp: 'Practice9',
	},
];
export default Practices;
